import React, { useEffect } from 'react';
import { Container, Row, Col, Card, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../ServicePage.css';

function SviluppoBackend() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const technologies = [
        "Node.js & Express.js",
        "Python & Django/FastAPI", 
        "PHP & Laravel/Symfony",
        "Java & Spring Boot",
        "C# & .NET Core",
        "Go & Gin/Echo",
        "GraphQL & REST APIs",
        "Microservices Architecture"
    ];

    const databases = [
        "MySQL & PostgreSQL",
        "MongoDB & Redis",
        "Elasticsearch",
        "InfluxDB (Time Series)",
        "Database optimization",
        "Query performance tuning",
        "Backup strategies",
        "Data migration"
    ];

    const cloudServices = [
        "AWS (EC2, Lambda, RDS)",
        "Google Cloud Platform",
        "Microsoft Azure",
        "Docker containerization",
        "Kubernetes orchestration",
        "CI/CD pipelines",
        "Load balancing",
        "Auto-scaling setup"
    ];

    const features = [
        "API design & documentation",
        "Authentication & Authorization",
        "Payment gateway integration",
        "Real-time notifications",
        "Background job processing",
        "Email & SMS services",
        "File upload & storage",
        "Third-party integrations"
    ];

    return (
        <div className="service-page">
            <Container>
                <div className="service-header">
                    <h1 className="service-title gradient-text">Sviluppo Backend</h1>
                    <p className="service-description">
                        API robuste e scalabili con Node.js, Python e database moderni.
                        Architetture backend performanti per applicazioni web e mobile.
                    </p>
                </div>

                <Row className="mb-5">
                        <Col lg={8}>
                            <div className="service-description">
                                <h3>Sviluppo Backend Professionale</h3>
                                <p>
                                    Progetto e sviluppo architetture backend scalabili e performanti utilizzando 
                                    le migliori tecnologie server-side. Dalle API REST ai microservizi,
                                    creo soluzioni backend robuste per applicazioni moderne.
                                </p>
                                <p>
                                    Esperienza completa nello sviluppo di sistemi distribuiti, integrazione 
                                    di database, implementazione di sicurezza avanzata e ottimizzazione 
                                    delle performance per carichi elevati.
                                </p>
                            </div>

                            <div className="technologies-section">
                                <h3>Tecnologie Backend</h3>
                                <Row>
                                    {technologies.map((tech, index) => (
                                        <Col md={6} key={index} className="mb-2">
                                            <div className="feature-item">
                                                <span className="feature-check">⚙️</span>
                                                {tech}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <div className="databases-section">
                                <h3>Database & Storage</h3>
                                <Row>
                                    {databases.map((db, index) => (
                                        <Col md={6} key={index} className="mb-2">
                                            <div className="feature-item">
                                                <span className="feature-check">🗄️</span>
                                                {db}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <Alert variant="success" className="backend-alert">
                                <h5><i className="fas fa-server"></i> Microservices & Scalability</h5>
                                <p>
                                    Progettazione di architetture microservizi con pattern di resilienza,
                                    service discovery, API gateway e distributed caching per massima scalabilità.
                                </p>
                            </Alert>

                            <div className="cloud-section">
                                <h3>Cloud & DevOps</h3>
                                <Row>
                                    {cloudServices.map((service, index) => (
                                        <Col md={6} key={index} className="mb-2">
                                            <div className="feature-item">
                                                <span className="feature-check">☁️</span>
                                                {service}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <div className="features-section">
                                <h3>Funzionalità Avanzate</h3>
                                <Row>
                                    {features.map((feature, index) => (
                                        <Col md={6} key={index} className="mb-2">
                                            <div className="feature-item">
                                                <span className="feature-check">🚀</span>
                                                {feature}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <div className="service-process">
                                <h3>Processo di Sviluppo</h3>
                                <div className="process-steps">
                                    <div className="process-step-item">
                                        <div className="step-number">1</div>
                                        <div className="step-text">Analisi requirements e design architetturale</div>
                                    </div>
                                    <div className="process-step-item">
                                        <div className="step-number">2</div>
                                        <div className="step-text">Setup infrastruttura e database design</div>
                                    </div>
                                    <div className="process-step-item">
                                        <div className="step-number">3</div>
                                        <div className="step-text">Sviluppo API con testing automatizzato</div>
                                    </div>
                                    <div className="process-step-item">
                                        <div className="step-number">4</div>
                                        <div className="step-text">Deploy, monitoring e ottimizzazione</div>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        <Col lg={4}>
                            <div className="service-sidebar">
                                <Card className="service-info-card">
                                    <Card.Body>
                                        <h4>Specializzazioni Backend</h4>
                                        <ul>
                                            <li>RESTful API design</li>
                                            <li>GraphQL implementation</li>
                                            <li>Microservices architecture</li>
                                            <li>Real-time systems</li>
                                            <li>High-performance computing</li>
                                            <li>Distributed systems</li>
                                        </ul>
                                    </Card.Body>
                                </Card>

                                <Card className="security-card">
                                    <Card.Body>
                                        <h4>🔒 Sicurezza</h4>
                                        <ul>
                                            <li>JWT & OAuth2</li>
                                            <li>Data encryption</li>
                                            <li>Input validation</li>
                                            <li>Rate limiting</li>
                                            <li>CORS configuration</li>
                                            <li>Security headers</li>
                                        </ul>
                                    </Card.Body>
                                </Card>

                                <Card className="monitoring-card">
                                    <Card.Body className="text-center">
                                        <h5>📊 Monitoring & Logging</h5>
                                        <ul style={{textAlign: 'left'}}>
                                            <li>Application performance monitoring</li>
                                            <li>Error tracking (Sentry)</li>
                                            <li>Structured logging</li>
                                            <li>Health checks</li>
                                            <li>Metrics collection</li>
                                        </ul>
                                    </Card.Body>
                                </Card>

                                <div className="cta-section">
                                    <a href="#contact" className="btn-gradient w-100 mb-3">
                                        <span>Richiedi Preventivo Backend</span>
                                    </a>
                                    <Link to="/services" className="btn btn-outline-primary w-100">
                                        Torna ai Servizi
                                    </Link>
                                </div>
                            </div>
                        </Col>
                </Row>
            </Container>
        </div>
    );
}

export default SviluppoBackend;